// external
import React, { FC } from 'react';

// internal
import './not-found.page.css';

const NotFoundPage: FC = () => {
  return (
    <div className="page not-found-page">
      <h1>404</h1>
      <h3>The page you were looking for does not exist</h3>
    </div>
  );
};

export default NotFoundPage;
